export default __webpack_public_path__ + "static/media/BuildBookBackground.461e1a4e.jpg";